<template>
  <div class="orderOverStyle">
    <top-component></top-component>
    <div class="orderContent">
      <el-tabs @tab-click="tabHandleClick" style="margin:20px auto;">
        <!-- 原有订单查询标签页 -->
        <el-tab-pane label="订单查询">
          <!-- 原有内容保持不变 -->
          <div class="dd">
            <div class="export_all">
              <Button size="small" type="primary" @click="exportOrder()">批量导出订单</Button>
              <Button size="small" v-if="adminState == '1'|| adminState == '0' " type="success"
                @click="exportAllOrder()">导出机构下所有订单</Button>
              <Button size="small" type="danger" @click="handleCommanddd()">订单导入</Button>
              <Button size="small" type="info" @click="handleCommand()">Marc数据转表格</Button>
              <Button size="small" type="warning" @click="converttabledatatomarc()">表格数据转Marc</Button>
              <Button size="small" type="primary" plain @click="externalprocurementmatching()">外采匹配</Button>
            </div>
            <el-table :data="tableData" style="width: 100%;margin-top: 15px;" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="48"></el-table-column>
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column prop="createTime" label="订单日期" width="150" align="center"></el-table-column>
              <el-table-column prop="customOrderId" label="订单编号" width="180" align="center"></el-table-column>
              <el-table-column prop="goodsType" label="订单类型" align="center" width="100">
                <template slot-scope="scope">
                  <span v-if="Number(scope.row.goodsType) === 1">纸质书</span>
                  <span v-else-if="Number(scope.row.goodsType) === 2">电子书</span>
                  <span v-else>非书籍</span>
                </template>
              </el-table-column>
              <el-table-column prop="totalPrice" label="订单总价" align="right" width="100"></el-table-column>
              <el-table-column prop="submitter" label="加购人" width="100" align="center"></el-table-column>
              <el-table-column prop="remark" label="操作人" width="100" align="center"></el-table-column>
              <el-table-column prop="name" label="操作" width="330px">
                <template slot-scope="scope">
                  <el-link type="primary" @click="DetailOrder(scope.row.orderId)">查看详情</el-link>
                  <el-link type="primary" @click="OrderDao(scope.row.orderId, 1)">导出订单</el-link>
                  <el-link type="primary" @click="OrderDao(scope.row.orderId, 2)">导出MARC</el-link>
                  <el-link type="primary" @click="balanceOrder(scope.row.orderId, 0)" v-if="scope.row.balance == 0">审核</el-link>
                  <el-link type="primary" @click="balanceOrder(scope.row.orderId, 1)" v-if="scope.row.balance == 0">结算</el-link>
                  <el-link type="primary" @click="removeOrder(scope.row.orderId, 1)" v-if="scope.row.balance == 0">删除</el-link>
                  <span style="color: #0fc50f;vertical-align: middle;" v-if="scope.row.balance == 1">已审核</span>
                  <span style="color: #ff0000;vertical-align: middle;" v-if="scope.row.balance == 1">已结算</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="pages.currentPage" :page-size="pages.pagesize" layout="prev, pager, next, jumper"
              :total="pages.total">
            </el-pagination>
          </div>
        </el-tab-pane>

        <!-- 新增：期刊订单标签页 -->
        <el-tab-pane label="期刊订单">
          <!-- 原有内容保持不变 -->
          <div class="periodical-order">
            <el-form :inline="true" :model="periodicalOrderQuery" class="demo-form-inline" style="margin: 15px 0;">
              <el-form-item label="期刊名称">
                <el-input v-model="periodicalOrderQuery.name" placeholder="请输入期刊名称"></el-input>
              </el-form-item>
              <el-form-item label="订单号">
                <el-input v-model="periodicalOrderQuery.orderNo" placeholder="请输入订单号"></el-input>
              </el-form-item>
              <el-form-item label="订购状态">
                <el-select v-model="periodicalOrderQuery.status" placeholder="请选择状态">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="已订购" value="1"></el-option>
                  <el-option label="已取消" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="queryPeriodicalOrders">查询</el-button>
                <el-button @click="resetPeriodicalOrderQuery">重置</el-button>
              </el-form-item>
            </el-form>

            <el-table :data="filteredPeriodicalOrders" style="width: 100%;">
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column prop="orderNo" label="订单号" width="180" align="center"></el-table-column>
              <el-table-column prop="name" label="期刊名称" align="center"></el-table-column>
              <el-table-column prop="issn" label="ISSN" width="120" align="center"></el-table-column>
              <el-table-column prop="frequency" label="刊期" width="100" align="center"></el-table-column>
              <el-table-column prop="startDate" label="起订日期" width="150" align="center"></el-table-column>
              <el-table-column prop="endDate" label="止订日期" width="150" align="center"></el-table-column>
              <el-table-column prop="amount" label="数量" width="80" align="center"></el-table-column>
              <el-table-column prop="totalPrice" label="总价" width="100" align="center"></el-table-column>
              <el-table-column prop="status" label="状态" width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.status === 1" style="color: green;">已订购</span>
                  <span v-else style="color: red;">已取消</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                  <el-link type="primary" @click="viewPeriodicalOrderDetail(scope.row)">查看详情</el-link>
                  <el-link type="primary" @click="checkArrivalInfo(scope.row)" v-if="scope.row.status === 1">到刊查询</el-link>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination 
              @size-change="handlePeriodicalOrderSizeChange" 
              @current-change="handlePeriodicalOrderCurrentChange"
              :current-page.sync="periodicalOrderPage.currentPage" 
              :page-size="periodicalOrderPage.pageSize" 
              layout="prev, pager, next, jumper"
              :total="filteredPeriodicalOrders.length">
            </el-pagination>
          </div>
        </el-tab-pane>

        <!-- 新增：订刊到刊信息查询标签页 -->
        <el-tab-pane label="订刊到刊信息查询">
          <!-- 原有内容保持不变 -->
          <div class="arrival-info">
            <el-form :inline="true" :model="arrivalQuery" class="demo-form-inline" style="margin: 15px 0;">
              <el-form-item label="期刊名称">
                <el-input v-model="arrivalQuery.periodicalName" placeholder="请输入期刊名称"></el-input>
              </el-form-item>
              <el-form-item label="订单号">
                <el-input v-model="arrivalQuery.orderNo" placeholder="请输入订单号"></el-input>
              </el-form-item>
              <el-form-item label="到刊状态">
                <el-select v-model="arrivalQuery.status" placeholder="请选择状态">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="已到刊" value="1"></el-option>
                  <el-option label="未到刊" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="queryArrivalInfo">查询</el-button>
                <el-button @click="resetArrivalQuery">重置</el-button>
              </el-form-item>
            </el-form>

            <el-table :data="filteredArrivalInfo" style="width: 100%;">
              <el-table-column prop="orderNo" label="订单号" width="180" align="center"></el-table-column>
              <el-table-column prop="periodicalName" label="期刊名称" align="center"></el-table-column>
              <el-table-column prop="issue" label="期号" width="100" align="center"></el-table-column>
              <el-table-column prop="publicationDate" label="出版日期" width="150" align="center"></el-table-column>
              <el-table-column prop="arrivalDate" label="到刊日期" width="150" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.arrivalDate">{{ scope.row.arrivalDate }}</span>
                  <span v-else style="color: #999;">未到刊</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.status === 1" style="color: green;">已到刊</span>
                  <span v-else style="color: orange;">未到刊</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-link type="primary" @click="confirmArrival(scope.row)" v-if="scope.row.status === 0">确认到刊</el-link>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination 
              @size-change="handleArrivalSizeChange" 
              @current-change="handleArrivalCurrentChange"
              :current-page.sync="arrivalPage.currentPage" 
              :page-size="arrivalPage.pageSize" 
              layout="prev, pager, next, jumper"
              :total="filteredArrivalInfo.length">
            </el-pagination>
          </div>
        </el-tab-pane>

        <!-- 智能推送/书目下载标签页（增强版） -->
        <el-tab-pane label="期刊征订目录下载">
          <!-- 原有内容保持不变 -->
          <div class="kj">
            <div class="journal-filter">
              <el-row :gutter="20" style="margin-bottom: 15px;">
                <el-col :span="8">
                  <el-input 
                    v-model="journalSearchQuery" 
                    placeholder="搜索期刊名称、ISSN或关键词" 
                    prefix-icon="el-icon-search"
                    @keyup.enter.native="searchJournals"
                  >
                    <el-button slot="append" icon="el-icon-search" @click="searchJournals"></el-button>
                  </el-input>
                </el-col>
                
                <el-col :span="16">
                  <el-form :inline="true" :model="filterForm" class="filter-form">
                    <el-form-item label="学科分类">
                      <el-select v-model="filterForm.subject" placeholder="请选择学科" @change="filterJournals">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="subject in subjects" :key="subject.id" :label="subject.name" :value="subject.id"></el-option>
                      </el-select>
                    </el-form-item>
                    
                    <el-form-item label="出版社">
                      <el-select v-model="filterForm.publisher" placeholder="请选择出版社" @change="filterJournals">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="pub in publishers" :key="pub" :label="pub" :value="pub"></el-option>
                      </el-select>
                    </el-form-item>
                    
                    
                    <el-form-item>
                      <el-button type="info" @click="resetFilters">重置筛选</el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>
            
            <div class="journal-actions" style="margin: 15px 0;">
              <el-button 
                type="primary" 
                @click="batchReserveSelected" 
                :disabled="selectedJournals.length === 0"
              >
                批量预订选中期刊
              </el-button>
              <el-button type="success" @click="showCollectionList = true">查看我的收藏</el-button>
              <el-button type="info" @click="showDownloadHistory = true">下载历史</el-button>
              <el-badge :value="selectedJournals.length" class="item" v-if="selectedJournals.length > 0">
                <span style="margin-left: 10px;">已选 {{ selectedJournals.length }} 项</span>
              </el-badge>
            </div>
            
            <el-table 
              :data="filteredJournalList" 
              style="width: 100%;margin-top: 15px;"
              @selection-change="handleJournalSelectionChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column prop="listTitle" label="期刊标题" min-width="200">
                <template slot-scope="scope">
                  <span @click="viewJournalDetail(scope.row)" class="journal-title">{{ scope.row.listTitle }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="issn" label="ISSN" width="120"></el-table-column>
              <el-table-column prop="publisher" label="出版社" width="150"></el-table-column>
              <el-table-column prop="publishDate" label="出版日期" width="130"></el-table-column>
              <el-table-column prop="subject" label="学科分类" width="120"></el-table-column>
              <el-table-column prop="listPeriods" label="期数" width="80"></el-table-column>
              <el-table-column prop="createDate" label="入库时间" width="130"></el-table-column>
              <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                  <el-link type="primary" @click="downBook(scope.row)">下载</el-link>
                  <el-link type="success" @click="reserveJournal(scope.row)">预订</el-link>
                  <el-link 
                    type="warning" 
                    @click="toggleCollection(scope.row)"
                    :icon="isCollected(scope.row) ? 'el-icon-star-on' : 'el-icon-star-off'"
                  >
                    {{ isCollected(scope.row) ? '取消收藏' : '收藏' }}
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
            
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 15px;">
              <Button size="small" type="warning" @click="batchdownBook()" :disabled="selectedJournals.length === 0">
                批量下载选中
              </Button>
              <el-pagination 
                @size-change="handleSizeChange2" 
                @current-change="handleCurrentChange2"
                :current-page.sync="currentPage" 
                :page-size="pageSize" 
                layout="total, sizes, prev, pager, next, jumper"
                :total="filteredJournalList.length"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>

        <!-- 原有统计分析标签页 -->
        <el-tab-pane label="统计分析">
          <!-- 原有内容保持不变 -->
          <div>
            <div style="display: flex; flex-wrap: wrap;">
              <div ref="barChart" style="width: 580px; height: 400px;"></div>
              <div ref="barChart1" style="width: 620px; height: 400px;"></div>
            </div>
            <div style="display: flex; flex-wrap: wrap;">
              <div ref="barChart2" style="width: 580px; height: 400px;"></div>
              <div ref="barChart3" style="width: 620px; height: 400px;"></div>
            </div>
            <div style="display: flex; flex-wrap: wrap;">
              <div ref="barChart4" style="width: 580px; height: 400px;"></div>
              <div ref="barChart5" style="width: 620px; height: 400px;"></div>
            </div>
          </div>
        </el-tab-pane>

        <!-- 重构：在线订购标签页（围绕畅销期刊和核心期刊检索） -->
        <el-tab-pane label="在线订购">
          <div class="journal-search-container">
            <!-- 检索区域 -->
            <div class="search-header">
              <h3>畅销期刊与核心期刊检索</h3>
              <el-form :inline="true" :model="journalSearchForm" class="search-form">
                <el-form-item label="期刊类型">
                  <el-radio-group v-model="journalSearchForm.type" @change="handleJournalTypeChange">
                    <el-radio-button label="all">全部期刊</el-radio-button>
                    <el-radio-button label="bestseller">畅销期刊</el-radio-button>
                    <el-radio-button label="core">核心期刊</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                
                <el-form-item label="检索方式">
                  <el-select v-model="journalSearchForm.searchType" placeholder="请选择">
                    <el-option label="期刊名称" value="name"></el-option>
                    <el-option label="ISSN" value="issn"></el-option>
                    <el-option label="关键词" value="keyword"></el-option>
                    <el-option label="学科分类" value="subject"></el-option>
                  </el-select>
                </el-form-item>
                
                <el-form-item>
                  <el-input 
                    v-model="journalSearchForm.keyword" 
                    placeholder="请输入检索内容" 
                    style="width: 300px;"
                    @keyup.enter.native="searchJournalsForOrder"
                  >
                    <el-button slot="append" icon="el-icon-search" @click="searchJournalsForOrder"></el-button>
                  </el-input>
                </el-form-item>
                
                <el-form-item>
                  <el-button type="info" @click="resetJournalSearch">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            
            <!-- 高级筛选区域 -->
            <div class="advanced-filter">
              <el-form :inline="true" :model="advancedFilterForm" class="filter-form">
                <el-form-item label="学科分类">
                  <el-select v-model="advancedFilterForm.subject" placeholder="请选择学科" @change="filterJournalsForOrder">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="subject in journalSubjects" :key="subject.id" :label="subject.name" :value="subject.id"></el-option>
                  </el-select>
                </el-form-item>
                
                <el-form-item label="影响因子">
                  <el-select v-model="advancedFilterForm.impactFactor" placeholder="请选择" @change="filterJournalsForOrder">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="≥3.0" value="high"></el-option>
                    <el-option label="1.0-3.0" value="medium"></el-option>
                    <el-option label="≤1.0" value="low"></el-option>
                  </el-select>
                </el-form-item>
                
                <el-form-item label="出版周期">
                  <el-select v-model="advancedFilterForm.frequency" placeholder="请选择" @change="filterJournalsForOrder">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="周刊" value="weekly"></el-option>
                    <el-option label="月刊" value="monthly"></el-option>
                    <el-option label="双月刊" value="bimonthly"></el-option>
                    <el-option label="季刊" value="quarterly"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            
            <!-- 期刊列表 -->
            <div class="journal-results">
              <div class="results-stats">
                <span>找到 {{ filteredJournalsForOrder.length }} 本符合条件的期刊</span>
                <el-select v-model="sortType" @change="sortJournals">
                  <el-option label="默认排序" value="default"></el-option>
                  <el-option label="按影响力排序" value="impact"></el-option>
                  <el-option label="按销量排序" value="sales"></el-option>
                  <el-option label="按出版日期排序" value="date"></el-option>
                </el-select>
              </div>
              
              <el-table 
                :data="filteredJournalsForOrder" 
                style="width: 100%; margin-top: 10px;"
                @selection-change="handleOrderJournalSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="期刊名称" min-width="200">
                  <template slot-scope="scope">
                    <span @click="viewOrderJournalDetail(scope.row)" class="journal-title">
                      {{ scope.row.name }}
                      <el-tag v-if="scope.row.isCore" size="mini" type="danger" style="margin-left: 5px;">核心期刊</el-tag>
                      <el-tag v-if="scope.row.isBestseller" size="mini" type="success" style="margin-left: 5px;">畅销</el-tag>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="issn" label="ISSN" width="120"></el-table-column>
                <el-table-column prop="subject" label="学科分类" width="120"></el-table-column>
                <el-table-column prop="impactFactor" label="影响因子" width="100">
                  <template slot-scope="scope">
                    <span :style="{color: scope.row.impactFactor >= 3 ? 'red' : (scope.row.impactFactor >= 1 ? 'orange' : 'green')}">
                      {{ scope.row.impactFactor }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="frequency" label="出版周期" width="100"></el-table-column>
                <el-table-column prop="publisher" label="出版社" width="150"></el-table-column>
                <el-table-column prop="price" label="单价" width="80" align="right"></el-table-column>
                <el-table-column label="操作" width="180">
                  <template slot-scope="scope">
                    <el-link type="primary" @click="addToOrderCart(scope.row)">加入订购车</el-link>
                    <el-link type="success" @click="quickOrder(scope.row)">立即订购</el-link>
                  </template>
                </el-table-column>
              </el-table>
              
              <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 15px;">
                <div v-if="orderCart.length > 0" class="cart-info">
                  <el-button type="primary" @click="showOrderCartDialog = true">
                    订购车 ({{ orderCart.length }})
                  </el-button>
                </div>
                <el-pagination 
                  @size-change="handleOrderPageSizeChange" 
                  @current-change="handleOrderCurrentPageChange"
                  :current-page.sync="orderPage.currentPage" 
                  :page-size="orderPage.pageSize" 
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="filteredJournalsForOrder.length"
                ></el-pagination>
              </div>
            </div>
          </div>
          
          <!-- 期刊详情对话框 -->
          <el-dialog title="期刊详情" :visible.sync="journalDetailDialogVisible" width="70%">
            <el-row :gutter="20" v-if="currentOrderJournal">
              <el-col :span="6">
                <div class="journal-cover">
                  <img :src="currentOrderJournal.coverUrl" alt="期刊封面" v-if="currentOrderJournal.coverUrl">
                  <div class="no-cover" v-else>无封面</div>
                </div>
                <div style="margin-top: 10px; text-align: center;">
                  <el-tag v-if="currentOrderJournal.isCore" type="danger" size="medium">核心期刊</el-tag>
                  <el-tag v-if="currentOrderJournal.isBestseller" type="success" size="medium" style="margin-left: 5px;">畅销期刊</el-tag>
                </div>
              </el-col>
              <el-col :span="18">
                <el-descriptions column="1" border>
                  <el-descriptions-item label="期刊名称">{{ currentOrderJournal.name }}</el-descriptions-item>
                  <el-descriptions-item label="ISSN">{{ currentOrderJournal.issn || '无' }}</el-descriptions-item>
                  <el-descriptions-item label="CN号">{{ currentOrderJournal.cn || '无' }}</el-descriptions-item>
                  <el-descriptions-item label="学科分类">{{ currentOrderJournal.subject }}</el-descriptions-item>
                  <el-descriptions-item label="影响因子">{{ currentOrderJournal.impactFactor }}</el-descriptions-item>
                  <el-descriptions-item label="出版社">{{ currentOrderJournal.publisher }}</el-descriptions-item>
                  <el-descriptions-item label="出版周期">{{ currentOrderJournal.frequency }}</el-descriptions-item>
                  <el-descriptions-item label="单价">{{ currentOrderJournal.price }} 元</el-descriptions-item>
                  <el-descriptions-item label="简介" :contentStyle="{whiteSpace: 'normal', verticalAlign: 'top'}">
                    {{ currentOrderJournal.description || '无简介' }}
                  </el-descriptions-item>
                </el-descriptions>
              </el-col>
            </el-row>
            <div slot="footer">
              <el-button @click="journalDetailDialogVisible = false">关闭</el-button>
              <el-button type="primary" @click="addToOrderCart(currentOrderJournal)">加入订购车</el-button>
              <el-button type="success" @click="quickOrder(currentOrderJournal)">立即订购</el-button>
            </div>
          </el-dialog>
          
          <!-- 订购车对话框 -->
          <el-dialog title="我的订购车" :visible.sync="showOrderCartDialog" width="70%">
            <el-table :data="orderCart" style="width: 100%;">
              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column prop="name" label="期刊名称" min-width="200"></el-table-column>
              <el-table-column prop="issn" label="ISSN" width="120"></el-table-column>
              <el-table-column prop="price" label="单价" width="80" align="right"></el-table-column>
              <el-table-column prop="quantity" label="订购数量" width="120">
                <template slot-scope="scope">
                  <el-input-number 
                    v-model="scope.row.quantity" 
                    :min="1" 
                    @change="updateCartTotal"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="小计" width="100" align="right">
                <template slot-scope="scope">
                  {{ (scope.row.price * scope.row.quantity).toFixed(2) }} 元
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button 
                    type="text" 
                    size="small" 
                    style="color: #ff4d4f;"
                    @click="removeFromCart(scope.$index)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <div style="text-align: right; margin-top: 15px;">
              <p>合计: <span style="font-size: 18px; color: #ff4d4f; font-weight: bold;">{{ cartTotal.toFixed(2) }}</span> 元</p>
            </div>
            
            <div slot="footer">
              <el-button @click="showOrderCartDialog = false">继续添加</el-button>
              <el-button type="primary" @click="submitOrder" :disabled="orderCart.length === 0">提交订购</el-button>
            </div>
          </el-dialog>
          
          <!-- 订购确认对话框 -->
          <el-dialog title="确认订购" :visible.sync="orderConfirmDialogVisible" width="60%">
            <el-form :model="orderForm" ref="orderForm" label-width="100px">
              <el-form-item label="订购期刊" prop="journalNames">
                <el-tag 
                  v-for="(item, index) in orderForm.journals" 
                  :key="index" 
                  closable 
                  @close="removeFromOrder(index)"
                >
                  {{ item.name }} ({{ item.quantity }}份)
                </el-tag>
              </el-form-item>
              <el-form-item label="订购人" prop="contactPerson" :rules="[{ required: true, message: '请输入订购人', trigger: 'blur' }]">
                <el-input v-model="orderForm.contactPerson"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="contactPhone" :rules="[{ required: true, message: '请输入联系电话', trigger: 'blur' }]">
                <el-input v-model="orderForm.contactPhone"></el-input>
              </el-form-item>
              <el-form-item label="配送地址" prop="deliveryAddress" :rules="[{ required: true, message: '请输入配送地址', trigger: 'blur' }]">
                <el-input type="textarea" v-model="orderForm.deliveryAddress" rows="3"></el-input>
              </el-form-item>
              <el-form-item label="付款方式" prop="paymentMethod" :rules="[{ required: true, message: '请选择付款方式', trigger: 'change' }]">
                <el-select v-model="orderForm.paymentMethod" placeholder="请选择">
                  <el-option label="银行转账" value="bank"></el-option>
                  <el-option label="在线支付" value="online"></el-option>
                  <el-option label="货到付款" value="cod"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单备注" prop="remark">
                <el-input type="textarea" v-model="orderForm.remark" rows="2"></el-input>
              </el-form-item>
              <el-form-item label="订单总金额">
                <span style="font-size: 16px; color: #ff4d4f; font-weight: bold;">{{ orderForm.totalAmount.toFixed(2) }} 元</span>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button @click="orderConfirmDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="confirmOrderSubmit">确认提交</el-button>
            </div>
          </el-dialog>
          
          <!-- 订购成功对话框 -->
          <el-dialog title="订购成功" :visible.sync="orderSuccessDialogVisible" width="50%" :show-close="false">
            <div style="text-align: center; padding: 30px 0;">
              <i class="el-icon-success" style="font-size: 60px; color: #13ce66; margin-bottom: 20px;"></i>
              <p style="font-size: 18px; margin-bottom: 10px;">您的期刊订购已提交成功！</p>
              <p>订单编号：<span style="font-weight: bold;">{{ successOrderNo }}</span></p>
              <p style="margin-top: 10px;">我们将尽快处理您的订单，请留意订单状态更新</p>
            </div>
            <div slot="footer" style="text-align: center;">
              <el-button type="primary" @click="gotoOrderList">查看我的订单</el-button>
              <el-button @click="orderSuccessDialogVisible = false">继续订购</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>

      <!-- 查看物流进度的对话框-->
      <el-dialog title="物流进度" :visible.sync="progessVisible" width="50%">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in progressInfo" :key="index" :timestamp="activity.time">
            {{ activity.context }}
          </el-timeline-item>
        </el-timeline>
      </el-dialog>

      <!-- 期刊订单详情对话框 -->
      <el-dialog title="期刊订单详情" :visible.sync="periodicalOrderDetailVisible" width="60%">
        <!-- 原有内容保持不变 -->
        <el-form ref="form" :model="currentPeriodicalOrder" label-width="120px">
          <el-form-item label="订单号">
            <span>{{ currentPeriodicalOrder.orderNo }}</span>
          </el-form-item>
          <el-form-item label="期刊名称">
            <span>{{ currentPeriodicalOrder.name }}</span>
          </el-form-item>
          <el-form-item label="ISSN">
            <span>{{ currentPeriodicalOrder.issn }}</span>
          </el-form-item>
          <el-form-item label="刊期">
            <span>{{ currentPeriodicalOrder.frequency }}</span>
          </el-form-item>
          <el-form-item label="起订日期">
            <span>{{ currentPeriodicalOrder.startDate }}</span>
          </el-form-item>
          <el-form-item label="止订日期">
            <span>{{ currentPeriodicalOrder.endDate }}</span>
          </el-form-item>
          <el-form-item label="数量">
            <span>{{ currentPeriodicalOrder.amount }}</span>
          </el-form-item>
          <el-form-item label="单价">
            <span>{{ currentPeriodicalOrder.unitPrice }}</span>
          </el-form-item>
          <el-form-item label="总价">
            <span>{{ currentPeriodicalOrder.totalPrice }}</span>
          </el-form-item>
          <el-form-item label="订购日期">
            <span>{{ currentPeriodicalOrder.orderDate }}</span>
          </el-form-item>
          <el-form-item label="状态">
            <span v-if="currentPeriodicalOrder.status === 1" style="color: green;">已订购</span>
            <span v-else style="color: red;">已取消</span>
          </el-form-item>
          <el-form-item label="备注">
            <span>{{ currentPeriodicalOrder.remark || '无' }}</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="periodicalOrderDetailVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 到刊信息详情对话框 -->
      <el-dialog title="到刊信息详情" :visible.sync="arrivalDetailVisible" width="50%">
        <!-- 原有内容保持不变 -->
        <el-table :data="currentArrivalList" style="width: 100%;">
          <el-table-column prop="issue" label="期号" width="100" align="center"></el-table-column>
          <el-table-column prop="publicationDate" label="出版日期" width="150" align="center"></el-table-column>
          <el-table-column prop="arrivalDate" label="到刊日期" width="150" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.arrivalDate">{{ scope.row.arrivalDate }}</span>
              <span v-else style="color: #999;">未到刊</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1" style="color: green;">已到刊</span>
              <span v-else style="color: orange;">未到刊</span>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="arrivalDetailVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 期刊详情对话框 -->
      <el-dialog title="期刊详情" :visible.sync="journalDetailVisible" width="70%">
        <!-- 原有内容保持不变 -->
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="journal-cover">
              <img :src="currentJournal.coverUrl" alt="期刊封面" v-if="currentJournal.coverUrl">
              <div class="no-cover" v-else>无封面</div>
            </div>
          </el-col>
          <el-col :span="18">
            <el-descriptions column="1" border>
              <el-descriptions-item label="期刊名称">{{ currentJournal.listTitle }}</el-descriptions-item>
              <el-descriptions-item label="ISSN">{{ currentJournal.issn || '无' }}</el-descriptions-item>
              <el-descriptions-item label="CN号">{{ currentJournal.cn || '无' }}</el-descriptions-item>
              <el-descriptions-item label="出版社">{{ currentJournal.publisher }}</el-descriptions-item>
              <el-descriptions-item label="主办单位">{{ currentJournal.sponsor || '无' }}</el-descriptions-item>
              <el-descriptions-item label="学科分类">{{ currentJournal.subject }}</el-descriptions-item>
              <el-descriptions-item label="刊期">{{ currentJournal.frequency || '无' }}</el-descriptions-item>
              <el-descriptions-item label="出版日期">{{ currentJournal.publishDate }}</el-descriptions-item>
              <el-descriptions-item label="简介" :contentStyle="{whiteSpace: 'normal', verticalAlign: 'top'}">
                {{ currentJournal.description || '无简介' }}
              </el-descriptions-item>
              <el-descriptions-item label="本期目录" :contentStyle="{whiteSpace: 'normal', verticalAlign: 'top'}">
                <ul v-if="currentJournal.contents && currentJournal.contents.length">
                  <li v-for="(item, index) in currentJournal.contents" :key="index">{{ item }}</li>
                </ul>
                <span v-else>无目录信息</span>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
        <div slot="footer">
          <el-button @click="journalDetailVisible = false">关闭</el-button>
          <el-button type="primary" @click="downBook(currentJournal)">下载</el-button>
          <el-button type="success" @click="reserveJournal(currentJournal)">{{ isReserved(currentJournal) ? '取消预订' : '预订' }}</el-button>
        </div>
      </el-dialog>

      <!-- 我的收藏对话框 -->
      <el-dialog title="我的收藏" :visible.sync="showCollectionList" width="80%">
        <!-- 原有内容保持不变 -->
        <el-table :data="collectedJournals" style="width: 100%;">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="listTitle" label="期刊标题" min-width="200"></el-table-column>
          <el-table-column prop="issn" label="ISSN" width="120"></el-table-column>
          <el-table-column prop="publisher" label="出版社" width="150"></el-table-column>
          <el-table-column prop="publishDate" label="出版日期" width="130"></el-table-column>
          <el-table-column prop="subject" label="学科分类" width="120"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-link type="primary" @click="downBook(scope.row)">下载</el-link>
              <el-link type="success" @click="reserveJournal(scope.row)">预订</el-link>
              <el-link type="danger" @click="toggleCollection(scope.row)">取消收藏</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer">
          <el-button @click="showCollectionList = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 下载历史对话框 -->
      <el-dialog title="下载历史" :visible.sync="showDownloadHistory" width="80%">
        <!-- 原有内容保持不变 -->
        <el-table :data="downloadHistory" style="width: 100%;">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="listTitle" label="期刊标题" min-width="200"></el-table-column>
          <el-table-column prop="issn" label="ISSN" width="120"></el-table-column>
          <el-table-column prop="downloadTime" label="下载时间" width="180"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="primary" @click="downBook(scope.row)">重新下载</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer">
          <el-button @click="showDownloadHistory = false">关闭</el-button>
          <el-button type="danger" @click="clearDownloadHistory">清空历史</el-button>
        </div>
      </el-dialog>

      <!-- 预订确认对话框 -->
      <el-dialog title="期刊预订" :visible.sync="reserveConfirmVisible" width="50%">
        <!-- 原有内容保持不变 -->
        <el-form :model="reserveForm" ref="reserveForm" label-width="100px">
          <el-form-item label="期刊名称" prop="journalName">
            <span>{{ reserveForm.journalName }}</span>
          </el-form-item>
          <el-form-item label="预订期数" prop="issues" :rules="[{ required: true, message: '请输入预订期数', trigger: 'blur' }]">
            <el-input v-model.number="reserveForm.issues" placeholder="例如：1-6表示预订1到6期"></el-input>
          </el-form-item>
          <el-form-item label="预订数量" prop="quantity" :rules="[{ required: true, type: 'number', min: 1, message: '请输入有效数量', trigger: 'blur' }]">
            <el-input v-model.number="reserveForm.quantity" type="number" min="1"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="reserveForm.remark" rows="3"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="reserveConfirmVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmReservation">确认预订</el-button>
        </div>
      </el-dialog>
    </div>

    <bottom-component></bottom-component>
  </div>
</template>

<script>
// 导入必要的组件和数据（保持不变）
import { allBooks } from '../../../src/dataJson/fullbooksData';
import { pcaTextArr } from "element-china-area-data";
import TopComponent from '../Components/TopComponentcopy.vue'
import BottomComponent from '../Components/BottomComponent.vue'
import { listOrders, exportOrder, exportAllOrder, exportMarc, balanceOrder, getremoveorder, publicationyearandmonthstatistics } from '@/api/pages'
import Cookies from 'js-cookie'
import FileSaver from 'file-saver';
import * as echarts from 'echarts';
import axios from 'axios';
import { Button } from 'element-ui'

// 模拟期刊数据（增强版）
const journalData = [
  {
    id: 1,
    listTitle: '中国图书馆学报',
    issn: '1001-8867',
    cn: '11-2746/G2',
    listPeriods: '第1期',
    createDate: '2023-01-10',
    publishDate: '2023-01-15',
    publisher: '北京图书馆出版社',
    sponsor: '国家图书馆',
    subject: '图书馆学',
    frequency: '月刊',
    attachUrl: '/journals/clj/202301.pdf',
    coverUrl: '/covers/clj202301.jpg',
    description: '《中国图书馆学报》是由国家图书馆主办的图书馆学专业核心期刊，反映图书馆学研究最新成果，交流图书馆工作经验，介绍国内外图书馆学动态。',
    contents: [
      '数字时代图书馆服务转型研究',
      '智慧图书馆建设的实践与思考',
      '图书馆资源共享模式创新'
    ]
  },
  // 其他期刊数据保持不变...
];

// 新增：用于在线订购的期刊数据（包含畅销和核心期刊标识）
const orderJournalData = [
  {
    id: 1,
    name: '中国图书馆学报',
    issn: '1001-8867',
    cn: '11-2746/G2',
    subject: '图书馆学',
    impactFactor: 3.2,
    isCore: true,
    isBestseller: true,
    publisher: '北京图书馆出版社',
    frequency: 'monthly',
    frequencyName: '月刊',
    price: 50,
    coverUrl: '/covers/clj202301.jpg',
    description: '《中国图书馆学报》是由国家图书馆主办的图书馆学专业核心期刊，反映图书馆学研究最新成果，交流图书馆工作经验，介绍国内外图书馆学动态。',
    salesVolume: 1200
  },
  {
    id: 2,
    name: '图书情报工作',
    issn: '0252-3116',
    cn: '11-1541/G2',
    subject: '情报学',
    impactFactor: 2.8,
    isCore: true,
    isBestseller: false,
    publisher: '科学技术文献出版社',
    frequency: 'bimonthly',
    frequencyName: '双月刊',
    price: 45,
    coverUrl: '/covers/tqg202303.jpg',
    description: '《图书情报工作》是综合性学术期刊，报道图书情报领域的理论研究和实践经验，推动学科发展和行业进步。',
    salesVolume: 850
  },
  {
    id: 3,
    name: '大学图书馆学报',
    issn: '1002-1027',
    cn: '11-2952/G2',
    subject: '高等教育',
    impactFactor: 1.5,
    isCore: false,
    isBestseller: true,
    publisher: '北京大学出版社',
    frequency: 'quarterly',
    frequencyName: '季刊',
    price: 40,
    coverUrl: '/covers/dxtsg202302.jpg',
    description: '《大学图书馆学报》主要报道高校图书馆的工作经验、学术研究成果以及国内外图书馆学发展动态。',
    salesVolume: 1500
  },
  {
    id: 4,
    name: '情报学报',
    issn: '1000-0135',
    cn: '11-2257/G3',
    subject: '情报学',
    impactFactor: 4.1,
    isCore: true,
    isBestseller: false,
    publisher: '科学出版社',
    frequency: 'monthly',
    frequencyName: '月刊',
    price: 60,
    coverUrl: '/covers/qbxb202301.jpg',
    description: '《情报学报》是中国情报学领域的核心期刊，发表情报学理论与实践研究的最新成果。',
    salesVolume: 720
  },
  {
    id: 5,
    name: '计算机应用',
    issn: '1001-9081',
    cn: '51-1307/TP',
    subject: '计算机科学',
    impactFactor: 2.3,
    isCore: true,
    isBestseller: true,
    publisher: '科学出版社',
    frequency: 'monthly',
    frequencyName: '月刊',
    price: 55,
    coverUrl: '/covers/jsjyy202301.jpg',
    description: '《计算机应用》报道计算机应用技术领域的最新研究成果和应用案例，涵盖人工智能、大数据等前沿领域。',
    salesVolume: 2100
  },
  {
    id: 6,
    name: '科技与创新',
    issn: '2095-6835',
    cn: '14-1369/N',
    subject: '科技综合',
    impactFactor: 0.8,
    isCore: false,
    isBestseller: true,
    publisher: '山西科技出版社',
    frequency: 'weekly',
    frequencyName: '周刊',
    price: 30,
    coverUrl: '/covers/kjycx202305.jpg',
    description: '《科技与创新》面向科技界、产业界、教育界，报道科技创新成果，普及科学知识，深受广大科技爱好者欢迎。',
    salesVolume: 3500
  }
];

// 期刊学科分类数据
const journalSubjects = [
  { id: 1, name: '图书馆学' },
  { id: 2, name: '情报学' },
  { id: 3, name: '计算机科学' },
  { id: 4, name: '高等教育' },
  { id: 5, name: '科技综合' }
];

// 其他原有数据定义保持不变...
const subjects = [
  { id: 1, name: '图书馆学' },
  { id: 2, name: '情报学' },
  { id: 3, name: '计算机科学' },
  { id: 4, name: '社会科学' },
  { id: 5, name: '高等教育' }
];

const publishers = [
  '北京图书馆出版社',
  '科学技术文献出版社',
  '北京大学出版社',
  '科学出版社',
  '中国社会科学出版社'
];

// 模拟期刊订单数据
const periodicalOrders = [
  {
    id: 1,
    orderNo: 'PER2023001',
    name: '中国图书馆学报',
    issn: '1001-8867',
    frequency: '月刊',
    startDate: '2023-01-01',
    endDate: '2023-12-31',
    amount: 12,
    unitPrice: 50,
    totalPrice: 600,
    orderDate: '2022-11-15',
    status: 1,
    remark: '年度订阅'
  },
  {
    id: 2,
    orderNo: 'PER2023002',
    name: '图书情报工作',
    issn: '0252-3116',
    frequency: '半月刊',
    startDate: '2023-01-01',
    endDate: '2023-12-31',
    amount: 24,
    unitPrice: 35,
    totalPrice: 840,
    orderDate: '2022-11-16',
    status: 1,
    remark: '年度订阅'
  },
  {
    id: 3,
    orderNo: 'PER2023003',
    name: '大学图书馆学报',
    issn: '1002-1027',
    frequency: '双月刊',
    startDate: '2023-01-01',
    endDate: '2023-12-31',
    amount: 6,
    unitPrice: 45,
    totalPrice: 270,
    orderDate: '2022-11-18',
    status: 0,
    remark: '已取消订阅'
  }
];

// 模拟到刊信息数据
const arrivalInfo = [
  {
    id: 1,
    orderNo: 'PER2023001',
    periodicalName: '中国图书馆学报',
    issue: '2023年第1期',
    publicationDate: '2023-01-15',
    arrivalDate: '2023-01-20',
    status: 1
  },
  {
    id: 2,
    orderNo: 'PER2023001',
    periodicalName: '中国图书馆学报',
    issue: '2023年第2期',
    publicationDate: '2023-02-15',
    arrivalDate: '2023-02-22',
    status: 1
  },
  {
    id: 3,
    orderNo: 'PER2023001',
    periodicalName: '中国图书馆学报',
    issue: '2023年第3期',
    publicationDate: '2023-03-15',
    arrivalDate: '',
    status: 0
  },
  {
    id: 4,
    orderNo: 'PER2023002',
    periodicalName: '图书情报工作',
    issue: '2023年第1期',
    publicationDate: '2023-01-05',
    arrivalDate: '2023-01-10',
    status: 1
  }
];

const mockData = {
  clcData: [
    { id: 'A', label: '马克思主义、列宁主义、毛泽东思想、邓小平理论', children: [
      { id: 'A1', label: '马克思、恩格斯著作' },
      { id: 'A2', label: '列宁著作' },
      { id: 'A3', label: '斯大林著作' }
    ]},
    { id: 'B', label: '哲学、宗教', children: [
      { id: 'B1', label: '世界哲学' },
      { id: 'B2', label: '中国哲学' },
      { id: 'B3', label: '亚洲哲学' }
    ]},
    { id: 'C', label: '社会科学总论', children: [
      { id: 'C1', label: '社会科学理论与方法' },
      { id: 'C93', label: '管理学' }
    ]}
  ],
  disciplineData: [
    { id: 'CS', label: '计算机科学', children: [
      { id: 'CS1', label: '软件工程' },
      { id: 'CS2', label: '人工智能' }
    ]},
    { id: 'PH', label: '哲学', children: [
      { id: 'PH1', label: '中国哲学' },
      { id: 'PH2', label: '西方哲学' }
    ]}
  ],
  keywordMapping: {
    'TP312': { keywords: ['编程', 'Java'], disciplines: ['计算机科学', '软件工程'] },
    'TP316': { keywords: ['算法'], disciplines: ['计算机科学', '数学'] }
  }
};

export default {
  name: 'HelloWorld',
  data() {
    return {
      // 原有数据保持不变...
      bookList: journalData,
      filteredJournalList: journalData,
      journalSearchQuery: '',
      selectedJournals: [],
      collectedJournals: [],
      downloadHistory: [],
      reservedJournals: [],
      showCollectionList: false,
      showDownloadHistory: false,
      journalDetailVisible: false,
      currentJournal: {},
      reserveConfirmVisible: false,
      reserveForm: {
        journalName: '',
        journalId: '',
        issues: '',
        quantity: 1,
        remark: ''
      },
      subjects: subjects,
      publishers: publishers,
      filterForm: {
        subject: '',
        publisher: '',
        publishDate: ''
      },
      periodicalOrders: periodicalOrders,
      filteredPeriodicalOrders: periodicalOrders,
      periodicalOrderQuery: {
        name: '',
        orderNo: '',
        status: ''
      },
      periodicalOrderPage: {
        currentPage: 1,
        pageSize: 10
      },
      periodicalOrderDetailVisible: false,
      currentPeriodicalOrder: {},
      arrivalInfo: arrivalInfo,
      filteredArrivalInfo: arrivalInfo,
      arrivalQuery: {
        periodicalName: '',
        orderNo: '',
        status: ''
      },
      arrivalPage: {
        currentPage: 1,
        pageSize: 10
      },
      arrivalDetailVisible: false,
      currentArrivalList: [],
      activeTab: 'mapping',
      clcData: mockData.clcData,
      disciplineData: mockData.disciplineData,
      keywordMapping: mockData.keywordMapping,
      allBooks: allBooks,
      books: [],
      newMapping: {
        clcCodes: [],
        keywords: [],
        disciplines: []
      },
      keywordInputVisible: false,
      keywordInputValue: '',
      filteredCount: null,
      pcaTextArr,
      selectedOptions: [],
      progessVisible: false,
      adminState: Cookies.get('adminState'),
      tabIndex: 0,
      pages: {
        currentPage: 1,
        pagesize: 10,
        total: 100
      },
      tableData: [],
      booktab: '2018020915511601905',
      currentPage: 1,
      pageSize: 20,
      total: journalData.length,
      orderIdArr: [],
      progressInfo: [
        {
          time: "2024-04-09 12:39:56",
          context: "已签收,签收人是 汤小洋 先生/女士"
        },
        {
          time: "2024-04-08 08:46:54",
          context: "上海浦东寒亭营业厅-寒亭阿奇(13805148888)-派件中"
        }
      ],
      
      // 新增：在线订购相关数据
      allJournalsForOrder: orderJournalData,
      filteredJournalsForOrder: orderJournalData,
      journalSubjects: journalSubjects,
      journalSearchForm: {
        type: 'all', // all, bestseller, core
        searchType: 'name',
        keyword: ''
      },
      advancedFilterForm: {
        subject: '',
        impactFactor: '',
        frequency: ''
      },
      sortType: 'default',
      orderPage: {
        currentPage: 1,
        pageSize: 10
      },
      selectedOrderJournals: [],
      orderCart: [],
      cartTotal: 0,
      currentOrderJournal: null,
      journalDetailDialogVisible: false,
      showOrderCartDialog: false,
      orderConfirmDialogVisible: false,
      orderForm: {
        journals: [],
        contactPerson: '',
        contactPhone: '',
        deliveryAddress: '',
        paymentMethod: '',
        remark: '',
        totalAmount: 0
      },
      orderSuccessDialogVisible: false,
      successOrderNo: ''
    }
  },
  mounted() {
    // 原有初始化逻辑保持不变
    this.ApiData();
    this.getBookList();
    this.initBarChart();
    this.initBarChart2();
    this.initBarChart3();
    this.loadStoredData();
  },
  computed: {
    // 原有计算属性保持不变
    displayMappings() {
      return Object.keys(this.keywordMapping).map(key => {
        return {
          clcCodes: key,
          keywords: this.keywordMapping[key].keywords,
          disciplines: this.keywordMapping[key].disciplines,
        };
      });
    },
  },
  created() {
    // 原有初始化逻辑保持不变
    this.books = [...this.allBooks];
  },
  methods: {
    // 原有方法保持不变...
    loadStoredData() {
      const storedCollections = localStorage.getItem('journalCollections');
      const storedDownloads = localStorage.getItem('journalDownloads');
      const storedReservations = localStorage.getItem('journalReservations');
      
      if (storedCollections) {
        this.collectedJournals = JSON.parse(storedCollections);
      }
      
      if (storedDownloads) {
        this.downloadHistory = JSON.parse(storedDownloads);
      }
      
      if (storedReservations) {
        this.reservedJournals = JSON.parse(storedReservations);
      }
    },
    
    saveToLocalStorage() {
      localStorage.setItem('journalCollections', JSON.stringify(this.collectedJournals));
      localStorage.setItem('journalDownloads', JSON.stringify(this.downloadHistory));
      localStorage.setItem('journalReservations', JSON.stringify(this.reservedJournals));
    },
    
    searchJournals() {
      if (!this.journalSearchQuery.trim()) {
        this.filteredJournalList = [...this.bookList];
        this.applyFilters();
        return;
      }
      
      const query = this.journalSearchQuery.toLowerCase();
      this.filteredJournalList = this.bookList.filter(journal => 
        journal.listTitle.toLowerCase().includes(query) || 
        (journal.issn && journal.issn.toLowerCase().includes(query)) ||
        (journal.subject && journal.subject.toLowerCase().includes(query))
      );
      
      this.applyFilters();
    },
    
    filterJournals() {
      this.filteredJournalList = [...this.bookList];
      this.searchJournals();
    },
    
    applyFilters() {
      if (this.filterForm.subject) {
        const subjectId = this.filterForm.subject;
        const subjectObj = this.subjects.find(s => s.id == subjectId);
        if (subjectObj && subjectObj.name) {
          const subjectName = subjectObj.name;
          this.filteredJournalList = this.filteredJournalList.filter(journal => 
            journal.subject === subjectName
          );
        }
      }
      
      if (this.filterForm.publisher) {
        this.filteredJournalList = this.filteredJournalList.filter(journal => 
          journal.publisher === this.filterForm.publisher
        );
      }
      
      if (this.filterForm.publishDate) {
        const filterDate = this.formatDate(this.filterForm.publishDate);
        this.filteredJournalList = this.filteredJournalList.filter(journal => 
          journal.publishDate.startsWith(filterDate)
        );
      }
      
      this.total = this.filteredJournalList.length;
      this.currentPage = 1;
    },
    
    resetFilters() {
      this.filterForm = {
        subject: '',
        publisher: '',
        publishDate: ''
      };
      this.journalSearchQuery = '';
      this.filteredJournalList = [...this.bookList];
      this.total = this.filteredJournalList.length;
    },
    
    handleJournalSelectionChange(val) {
      this.selectedJournals = val;
    },
    
    viewJournalDetail(journal) {
      this.currentJournal = { ...journal };
      this.journalDetailVisible = true;
    },
    
    toggleCollection(journal) {
      const index = this.collectedJournals.findIndex(item => item.id === journal.id);
      
      if (index > -1) {
        this.collectedJournals.splice(index, 1);
        this.$message.success('已取消收藏');
      } else {
        this.collectedJournals.push({ ...journal });
        this.$message.success('收藏成功');
      }
      
      this.saveToLocalStorage();
    },
    
    isCollected(journal) {
      return this.collectedJournals.some(item => item.id === journal.id);
    },
    
    downBook(row) {
      window.open('http://www.ytzhihui.com/ecp/down.download?filePath=' + row.attachUrl, '_blank');
      
      const now = new Date();
      const downloadTime = now.toLocaleString();
      
      const index = this.downloadHistory.findIndex(item => item.id === row.id);
      if (index > -1) {
        this.downloadHistory[index].downloadTime = downloadTime;
      } else {
        this.downloadHistory.unshift({ ...row, downloadTime });
      }
      
      if (this.downloadHistory.length > 100) {
        this.downloadHistory.pop();
      }
      
      this.saveToLocalStorage();
      this.$message.success('下载已开始');
    },
    
    batchdownBook() {
      if (this.selectedJournals.length === 0) {
        this.$message.warning('请先选择要下载的期刊');
        return;
      }
      
      this.selectedJournals.forEach(journal => {
        this.downBook(journal);
      });
      
      this.$message.success(`已开始批量下载${this.selectedJournals.length}本期刊`);
    },
    
    reserveJournal(journal) {
      if (this.isReserved(journal)) {
        const index = this.reservedJournals.findIndex(item => item.id === journal.id);
        if (index > -1) {
          this.reservedJournals.splice(index, 1);
          this.saveToLocalStorage();
          this.$message.success('已取消预订');
        }
        return;
      }
      
      this.reserveForm = {
        journalName: journal.listTitle,
        journalId: journal.id,
        issues: '',
        quantity: 1,
        remark: ''
      };
      this.reserveConfirmVisible = true;
    },
    
    confirmReservation() {
      this.$refs.reserveForm.validate((valid) => {
        if (valid) {
          const journal = this.bookList.find(item => item.id == this.reserveForm.journalId);
          if (journal) {
            this.reservedJournals.push({
              ...journal,
              reserveIssues: this.reserveForm.issues,
              reserveQuantity: this.reserveForm.quantity,
              reserveRemark: this.reserveForm.remark,
              reserveTime: new Date().toLocaleString()
            });
            
            this.saveToLocalStorage();
            this.$message.success('预订成功');
            this.reserveConfirmVisible = false;
          }
        }
      });
    },
    
    isReserved(journal) {
      return this.reservedJournals.some(item => item.id === journal.id);
    },
    
    batchReserveSelected() {
      if (this.selectedJournals.length === 0) {
        this.$message.warning('请先选择要预订的期刊');
        return;
      }
      
      const now = new Date().toLocaleString();
      
      this.selectedJournals.forEach(journal => {
        if (!this.isReserved(journal)) {
          this.reservedJournals.push({
            ...journal,
            reserveIssues: journal.listPeriods,
            reserveQuantity: 1,
            reserveRemark: '批量预订',
            reserveTime: now
          });
        }
      });
      
      this.saveToLocalStorage();
      this.$message.success(`已成功预订${this.selectedJournals.length}本期刊`);
    },
    
    clearDownloadHistory() {
      this.$confirm('确定要清空所有下载历史吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.downloadHistory = [];
        this.saveToLocalStorage();
        this.$message.success('下载历史已清空');
      }).catch(() => {
      });
    },
    
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      return `${year}-${month}`;
    },

    queryPeriodicalOrders() {
      this.periodicalOrderPage.currentPage = 1;
      this.filteredPeriodicalOrders = this.periodicalOrders.filter(order => {
        const matchesName = order.name.toLowerCase().includes(this.periodicalOrderQuery.name.toLowerCase());
        const matchesOrderNo = order.orderNo.includes(this.periodicalOrderQuery.orderNo);
        const matchesStatus = this.periodicalOrderQuery.status === '' || order.status.toString() === this.periodicalOrderQuery.status;
        return matchesName && matchesOrderNo && matchesStatus;
      });
    },

    resetPeriodicalOrderQuery() {
      this.periodicalOrderQuery = {
        name: '',
        orderNo: '',
        status: ''
      };
      this.queryPeriodicalOrders();
    },

    viewPeriodicalOrderDetail(order) {
      this.currentPeriodicalOrder = { ...order };
      this.periodicalOrderDetailVisible = true;
    },

    handlePeriodicalOrderSizeChange(val) {
      this.periodicalOrderPage.pageSize = val;
      this.periodicalOrderPage.currentPage = 1;
    },
    
    handlePeriodicalOrderCurrentChange(val) {
      this.periodicalOrderPage.currentPage = val;
    },

    queryArrivalInfo() {
      this.arrivalPage.currentPage = 1;
      this.filteredArrivalInfo = this.arrivalInfo.filter(info => {
        const matchesName = info.periodicalName.toLowerCase().includes(this.arrivalQuery.periodicalName.toLowerCase());
        const matchesOrderNo = info.orderNo.includes(this.arrivalQuery.orderNo);
        const matchesStatus = this.arrivalQuery.status === '' || info.status.toString() === this.arrivalQuery.status;
        return matchesName && matchesOrderNo && matchesStatus;
      });
    },

    resetArrivalQuery() {
      this.arrivalQuery = {
        periodicalName: '',
        orderNo: '',
        status: ''
      };
      this.queryArrivalInfo();
    },

    checkArrivalInfo(order) {
      this.currentArrivalList = this.arrivalInfo.filter(info => info.orderNo === order.orderNo);
      this.arrivalDetailVisible = true;
    },

    confirmArrival(info) {
      this.$confirm('确认该期刊已到刊？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        const index = this.arrivalInfo.findIndex(item => item.id === info.id);
        if (index !== -1) {
          this.arrivalInfo[index].status = 1;
          this.arrivalInfo[index].arrivalDate = new Date().toLocaleDateString();
          this.queryArrivalInfo();
        }
        this.$message({
          type: 'success',
          message: '已确认到刊'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认'
        });
      });
    },

    handleArrivalSizeChange(val) {
      this.arrivalPage.pageSize = val;
      this.arrivalPage.currentPage = 1;
    },
    
    handleArrivalCurrentChange(val) {
      this.arrivalPage.currentPage = val;
    },

    saveMapping() {
      const checkedClcNodes = this.$refs.clcTree.getCheckedNodes();
      const checkedDisciplineNodes = this.$refs.disciplineTree.getCheckedNodes();
      
      if (checkedClcNodes.length === 0 || (this.newMapping.keywords.length === 0 && checkedDisciplineNodes.length === 0)) {
        this.$message.warning('请选择中图法分类并至少添加一个主题词或学科名称');
        return;
      }
      
      const clcCodes = checkedClcNodes.map(node => node.id);
      const disciplines = checkedDisciplineNodes.map(node => node.label);
      
      clcCodes.forEach(code => {
        this.$set(this.keywordMapping, code, {
          keywords: [...this.newMapping.keywords],
          disciplines: [...disciplines],
        });
      });
      
      this.newMapping.keywords = [];
      this.newMapping.disciplines = [];
      this.$refs.clcTree.setCheckedKeys([]);
      this.$refs.disciplineTree.setCheckedKeys([]);
      this.$message.success('对应关系保存成功！');
    },
    
    handleClose(tag) {
      this.newMapping.keywords.splice(this.newMapping.keywords.indexOf(tag), 1);
    },
    
    showInput() {
      this.keywordInputVisible = true;
      this.$nextTick(_ => { this.$refs.keywordTagInput.$refs.input.focus(); });
    },
    
    handleInputConfirm() {
      let inputValue = this.keywordInputValue.trim();
      if (inputValue) {
        this.newMapping.keywords.push(inputValue);
      }
      this.keywordInputVisible = false;
      this.keywordInputValue = '';
    },
    
    autoFilter() {
      const { clcCode, discipline } = this.filterForm;
      let originalBookCount = this.books.length;
      let filteredBooks = this.allBooks;

      if (clcCode && clcCode.length > 0) {
        const clcCodesToKeep = clcCode.map(path => path[path.length - 1]);
        filteredBooks = filteredBooks.filter(book => {
          return clcCodesToKeep.includes(book.clcCode);
        });
      }

      if (discipline && discipline.length > 0) {
        const disciplinesToKeep = discipline.map(path => path[path.length - 1]);
        filteredBooks = filteredBooks.filter(book => {
          return book.disciplines.some(d => disciplinesToKeep.includes(d));
        });
      }

      filteredBooks = filteredBooks.filter(book => {
        const mapping = this.keywordMapping[book.clcCode];
        if (!mapping) {
          return false;
        }
        
        const hasValidKeyword = book.keywords.some(k => mapping.keywords.includes(k));
        const hasValidDiscipline = book.disciplines.some(d => mapping.disciplines.includes(d));
        
        return hasValidKeyword || hasValidDiscipline;
      });

      this.books = filteredBooks;
      this.filteredCount = originalBookCount - this.books.length;
      this.$message.success('图书已根据要求自动剔除！');
    },
    
    manualRemove(index) {
      this.books.splice(index, 1);
      this.$message.info('已手动剔除该图书');
    },
    
    resetData() {
      this.books = [...this.allBooks];
      this.keywordMapping = JSON.parse(JSON.stringify(mockData.keywordMapping));
      this.filteredCount = null;
      this.filterForm.clcCode = [];
      this.filterForm.discipline = [];
      this.activeTab = 'mapping';
      this.$message.success('数据已重置到初始状态');
    },
    
    getBookList() {
      this.bookList = journalData;
      this.filteredJournalList = journalData;
      this.total = journalData.length;
    },
    
    booktypeHandleClick(tab, event) {
      this.currentPage = 1;
      this.pageSize = 20;
      this.getBookList();
    },
    
    handleChange() {
      console.log(this.selectedOptions, 'selectedOptions');
    },
    
    handleSelectionChange(val) {
      let vm = this;
      vm.orderIdArr = [];
      val.forEach((ele, index) => {
        vm.orderIdArr.push(ele.orderId);
      });
    },
    
    exportOrder() {
      let vm = this;
      if (vm.orderIdArr.length > 0) {
        vm.OrderDao(vm.orderIdArr.join(), 1);
      } else {
        vm.$message({
          message: '至少选择一条订单数据才可批量导出！',
          type: 'warning'
        });
      }
    },
    
    tabHandleClick(tab, event) {
      let vm = this;
      vm.tabIndex = tab.index;
      vm.tableData = [];
      if (vm.tabIndex == 3) {
        vm.getBookList();
      } else {
        vm.ApiData();
      }
    },
    
    handleCommanddd() {
      if (Cookies.get("token")) {
        this.$router.push({ name: "ImportOrder3" });
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    
    handleCommand() {
      if (Cookies.get("token")) {
        this.$router.push({ name: "ImportOrder" });
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    
    converttabledatatomarc() {
      if (Cookies.get("token")) {
        this.$router.push({ name: "ImportMarc" });
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    
    externalprocurementmatching() {
      if (Cookies.get("token")) {
        this.$router.push({ name: "externalprocurementmatching" });
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    
    ApiData() {
      var obj = {
        userId: Cookies.get('UserID'),
        pageNum: this.pages.currentPage,
        pageSize: this.pages.pagesize,
      }
      listOrders(obj).then(response => {
        this.tableData = response.data.list
        this.pages.total = response.data.total
      })
    },
    
    removeOrder(orderId) {
      this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getremoveorder({ orderId: orderId }).then(response => {
          if (response.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.ApiData();
          } else {
            this.$message({
              type: 'error',
              message: '删除失败，请稍后重试。'
            });
          }
        }).catch(error => {
          console.error('API call failed:', error);
          this.$message({
            type: 'error',
            message: '删除失败，网络请求异常。'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    
    balanceOrder(orderId, type) {
      let vm = this,
        str = '',
        obj = {
          orderId: orderId,
          balance: 1
        };
      type == 0 ? str = "审核通过" : str = "结算";
      vm.$confirm("确定要" + str + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        balanceOrder(obj).then(res => {
          if (res.status) {
            vm.$message({
              message: str + "成功！",
              type: 'success'
            });
            vm.ApiData();
          }
        });
      }).catch(() => { });
    },
    
    DetailOrder(orderId) {
      this.$router.push({ name: 'OrderDetail', query: { orderId: orderId } })
    },
    
    async exportAllOrder() {
      axios.post('sxtucaihui/order/action/exportAllStream',
        {
          orgId: Cookies.get('orgGid')
        },
        {
          responseType: 'blob',
          headers: {
            'datasource': Cookies.get('logintype'),
            'source': Cookies.get('source'),

          }
        })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
          FileSaver.saveAs(blob, '全部订单.xlsx');
          this.$message({
            message: "导出成功",
            type: "success",
            duration: 2000,
          });

        }).catch(error => {
          this.$message({
            message: "导出失败",
            type: "warning",
            duration: 2000,
          });
        });
    },
    
    async OrderDao(orderId, type) {
      if (type == 1) {
        axios.post('sxtucaihui/order/action/exportOrderStream',
          {
            orderId: orderId,
            userName: Cookies.get('name')
          },
          {
            responseType: 'blob',
            headers: {
              'datasource': Cookies.get('logintype'),
              'source': Cookies.get('source'),

            }
          }).then(response => {
            const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
            FileSaver.saveAs(blob, '订单汇总.xlsx');
            this.$message({
              message: "导出成功",
              type: "success",
              duration: 2000,
            });

          }).catch(error => {
            this.$message({
              message: "导出失败",
              type: "warning",
              duration: 2000,
            });
          });
      } else {
        axios.post('sxtucaihui/order/action/exportMarcStream',
          {
            orderId: orderId,
            userName: Cookies.get('name')
          },
          {
            responseType: 'blob',
            headers: {
              'datasource': Cookies.get('logintype'),
              'source': Cookies.get('source'),

            }
          })
          .then(response => {
            const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
            FileSaver.saveAs(blob, 'MARC.iso');
            this.$message({
              message: "导出成功",
              type: "success",
              duration: 2000,
            });

          }).catch(error => {
            this.$message({
              message: "导出失败",
              type: "warning",
              duration: 2000,
            });
          });
      }
    },
    
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    
    bcaddress() {
      this.$message({
        message: "保存成功！",
        type: "warning",
        duration: 2000,
      });
    },
    
    async initBarChart() {
      let barChart = echarts.init(this.$refs.barChart);
      let barChart1 = echarts.init(this.$refs.barChart1);
      let obj = {
        name: "cbny",
        orgid: Cookies.get('orgGid')
      }
      let res = await publicationyearandmonthstatistics(obj)
      if (res.code == '200') {
        this.initBarChartdata = res.data
        if (this.initBarChartdata.length > 0) {
          var xAxisData = this.initBarChartdata.map(function (item) {
            return item.name;
          });
          var seriesData = this.initBarChartdata.map(function (item) {
            return item.total;
          });
          var seriesData1 = this.initBarChartdata.map(function (item) {
            return item.totalPrice;
          });
        }
      }

      let barOption = {
        title: {
          text: '出版年月统计(册)',
          left: 'center'
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: seriesData,
          type: 'bar',
          name: '册数',
        }]
      };
      let barOption1 = {
        title: {
          text: '出版年月统计(码洋)',
          left: 'center'
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: seriesData1,
          type: 'bar',
          name: '码洋',
        }]
      };
      barChart.setOption(barOption);
      barChart1.setOption(barOption1);
    },
    
    async initBarChart2() {
      let lineChart2 = echarts.init(this.$refs.barChart2);
      let lineChart3 = echarts.init(this.$refs.barChart3);

      let obj = {
        name: "ztf",
        orgid: Cookies.get('orgGid')
      }
      let res = await publicationyearandmonthstatistics(obj)
      if (res.code == '200') {
        this.initBarChartdata = res.data
        if (this.initBarChartdata.length > 0) {
          var xAxisData = this.initBarChartdata.map(function (item) {
            return item.name;
          });
          var seriesData = this.initBarChartdata.map(function (item) {
            return item.total;
          });
          var seriesData1 = this.initBarChartdata.map(function (item) {
            return item.totalPrice;
          });
        }
      }
      let lineOption1 = {
        title: {
          text: '学科专业(册)',
          left: 'center'
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: seriesData,
          type: 'line',
          name: '册数',
        }]
      };
      let lineOption2 = {
        title: {
          text: '学科专业(码洋)',
          left: 'center'
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: seriesData1,
          type: 'line',
          name: '码洋',
        }]
      };
      lineChart2.setOption(lineOption1);
      lineChart3.setOption(lineOption2);
    },
    
    async initBarChart3() {
      let lineChart2 = echarts.init(this.$refs.barChart4);
      let lineChart3 = echarts.init(this.$refs.barChart5);

      let obj = {
        name: "username",
        orgid: Cookies.get('orgGid')
      }
      let res = await publicationyearandmonthstatistics(obj)
      if (res.code == '200') {
        this.initBarChartdata = res.data
        if (this.initBarChartdata.length > 0) {
          var xAxisData = this.initBarChartdata.map(function (item) {
            return item.name;
          });
          var seriesData = this.initBarChartdata.map(function (item) {
            return { value: item.total, name: item.name };
          });
          var seriesData1 = this.initBarChartdata.map(function (item) {
            return { value: item.totalPrice, name: item.name };
          });
        }
      }
      let lineOption1 = {
        title: {
          text: '荐购(数量)',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        series: [{
          data: seriesData,
          type: 'pie',
          name: '册数',
        }]
      };
      let lineOption2 = {
        title: {
          text: '荐购(码洋)',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        series: [{
          data: seriesData1,
          type: 'pie',
          name: '码洋',
        }]
      };
      lineChart2.setOption(lineOption1);
      lineChart3.setOption(lineOption2);
    },
    
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.pages.currentPage = val
      this.ApiData()
    },
    
    handleSizeChange2(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val;
      this.getBookList();
    },
    
    handleCurrentChange2(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getBookList()
    },
    
    // 新增：在线订购相关方法
    /**
     * 处理期刊类型切换
     */
    handleJournalTypeChange() {
      this.filteredJournalsForOrder = [...this.allJournalsForOrder];
      this.applyJournalTypeFilter();
      this.applyAdvancedFilters();
    },
    
    /**
     * 应用期刊类型筛选（畅销/核心）
     */
    applyJournalTypeFilter() {
      if (this.journalSearchForm.type === 'bestseller') {
        this.filteredJournalsForOrder = this.filteredJournalsForOrder.filter(journal => journal.isBestseller);
      } else if (this.journalSearchForm.type === 'core') {
        this.filteredJournalsForOrder = this.filteredJournalsForOrder.filter(journal => journal.isCore);
      }
    },
    
    /**
     * 搜索期刊（在线订购）
     */
    searchJournalsForOrder() {
      this.filteredJournalsForOrder = [...this.allJournalsForOrder];
      this.applyJournalTypeFilter();
      
      if (!this.journalSearchForm.keyword.trim()) {
        this.applyAdvancedFilters();
        return;
      }
      
      const query = this.journalSearchForm.keyword.toLowerCase();
      
      this.filteredJournalsForOrder = this.filteredJournalsForOrder.filter(journal => {
        if (this.journalSearchForm.searchType === 'name') {
          return journal.name.toLowerCase().includes(query);
        } else if (this.journalSearchForm.searchType === 'issn') {
          return journal.issn.toLowerCase().includes(query);
        } else if (this.journalSearchForm.searchType === 'keyword') {
          return journal.description.toLowerCase().includes(query);
        } else if (this.journalSearchForm.searchType === 'subject') {
          return journal.subject.toLowerCase().includes(query);
        }
        return false;
      });
      
      this.applyAdvancedFilters();
    },
    
    /**
     * 应用高级筛选条件
     */
    applyAdvancedFilters() {
      // 学科筛选
      if (this.advancedFilterForm.subject) {
        const subjectId = this.advancedFilterForm.subject;
        const subjectObj = this.journalSubjects.find(s => s.id == subjectId);
        if (subjectObj && subjectObj.name) {
          this.filteredJournalsForOrder = this.filteredJournalsForOrder.filter(journal => 
            journal.subject === subjectObj.name
          );
        }
      }
      
      // 影响因子筛选
      if (this.advancedFilterForm.impactFactor) {
        if (this.advancedFilterForm.impactFactor === 'high') {
          this.filteredJournalsForOrder = this.filteredJournalsForOrder.filter(journal => 
            journal.impactFactor >= 3.0
          );
        } else if (this.advancedFilterForm.impactFactor === 'medium') {
          this.filteredJournalsForOrder = this.filteredJournalsForOrder.filter(journal => 
            journal.impactFactor >= 1.0 && journal.impactFactor < 3.0
          );
        } else if (this.advancedFilterForm.impactFactor === 'low') {
          this.filteredJournalsForOrder = this.filteredJournalsForOrder.filter(journal => 
            journal.impactFactor < 1.0
          );
        }
      }
      
      // 出版周期筛选
      if (this.advancedFilterForm.frequency) {
        this.filteredJournalsForOrder = this.filteredJournalsForOrder.filter(journal => 
          journal.frequency === this.advancedFilterForm.frequency
        );
      }
      
      // 排序
      this.sortJournals();
      
      // 重置分页
      this.orderPage.currentPage = 1;
    },
    
    /**
     * 筛选期刊（在线订购）
     */
    filterJournalsForOrder() {
      this.filteredJournalsForOrder = [...this.allJournalsForOrder];
      this.applyJournalTypeFilter();
      this.applyAdvancedFilters();
    },
    
    /**
     * 重置期刊搜索条件
     */
    resetJournalSearch() {
      this.journalSearchForm = {
        type: 'all',
        searchType: 'name',
        keyword: ''
      };
      this.advancedFilterForm = {
        subject: '',
        impactFactor: '',
        frequency: ''
      };
      this.sortType = 'default';
      this.filteredJournalsForOrder = [...this.allJournalsForOrder];
      this.orderPage.currentPage = 1;
    },
    
    /**
     * 排序期刊列表
     */
    sortJournals() {
      if (this.sortType === 'impact') {
        this.filteredJournalsForOrder.sort((a, b) => b.impactFactor - a.impactFactor);
      } else if (this.sortType === 'sales') {
        this.filteredJournalsForOrder.sort((a, b) => b.salesVolume - a.salesVolume);
      } else if (this.sortType === 'date') {
        this.filteredJournalsForOrder.sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate));
      }
    },
    
    /**
     * 处理期刊选择变化
     */
    handleOrderJournalSelectionChange(val) {
      this.selectedOrderJournals = val;
    },
    
    /**
     * 查看期刊详情
     */
    viewOrderJournalDetail(journal) {
      this.currentOrderJournal = { ...journal };
      this.journalDetailDialogVisible = true;
    },
    
    /**
     * 添加到订购车
     */
    addToOrderCart(journal) {
      const existingItemIndex = this.orderCart.findIndex(item => item.id === journal.id);
      
      if (existingItemIndex > -1) {
        // 已存在，数量加1
        this.orderCart[existingItemIndex].quantity += 1;
      } else {
        // 新添加
        this.orderCart.push({ ...journal, quantity: 1 });
      }
      
      this.updateCartTotal();
      this.$message.success('已添加到订购车');
    },
    
    /**
     * 从订购车移除
     */
    removeFromCart(index) {
      this.orderCart.splice(index, 1);
      this.updateCartTotal();
    },
    
    /**
     * 更新购物车总价
     */
    updateCartTotal() {
      this.cartTotal = this.orderCart.reduce((total, item) => {
        return total + (item.price * item.quantity);
      }, 0);
    },
    
    /**
     * 立即订购
     */
    quickOrder(journal) {
      // 清空当前订购车，只添加当前期刊
      this.orderCart = [{ ...journal, quantity: 1 }];
      this.updateCartTotal();
      
      // 直接进入订单确认
      this.prepareOrderForm();
      this.orderConfirmDialogVisible = true;
    },
    
    /**
     * 准备订单表单数据
     */
    prepareOrderForm() {
      this.orderForm = {
        journals: [...this.orderCart],
        contactPerson: '',
        contactPhone: '',
        deliveryAddress: '',
        paymentMethod: '',
        remark: '',
        totalAmount: this.cartTotal
      };
    },
    
    /**
     * 从订单中移除期刊
     */
    removeFromOrder(index) {
      this.orderForm.journals.splice(index, 1);
      this.orderForm.totalAmount = this.orderForm.journals.reduce((total, item) => {
        return total + (item.price * item.quantity);
      }, 0);
    },
    
    /**
     * 提交订单
     */
    submitOrder() {
      this.prepareOrderForm();
      this.showOrderCartDialog = false;
      this.orderConfirmDialogVisible = true;
    },
    
    /**
     * 确认提交订单
     */
    confirmOrderSubmit() {
      this.$refs.orderForm.validate((valid) => {
        if (valid) {
          // 生成随机订单号
          this.successOrderNo = 'ORD' + Date.now() + Math.floor(Math.random() * 1000);
          
          // 模拟订单提交成功
          this.orderConfirmDialogVisible = false;
          this.orderCart = [];
          this.updateCartTotal();
          this.orderSuccessDialogVisible = true;
        }
      });
    },
    
    /**
     * 前往订单列表
     */
    gotoOrderList() {
      this.orderSuccessDialogVisible = false;
      // 切换到订单查询标签页
      this.tabIndex = 0;
      this.ApiData();
    },
    
    /**
     * 处理分页大小变化
     */
    handleOrderPageSizeChange(val) {
      this.orderPage.pageSize = val;
      this.orderPage.currentPage = 1;
    },
    
    /**
     * 处理当前页变化
     */
    handleOrderCurrentPageChange(val) {
      this.orderPage.currentPage = val;
    }
  },
  components: { TopComponent, BottomComponent, Button }
}
</script>

<style scoped lang="scss">
  /* 原有样式保持不变 */
  .orderOverStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  .orderContent {
    width: 1250px;
    margin-left: calc(50% - 600px);

    .export_all {
      padding: 10px;
      margin-top: 15px;
      background-color: #fff;
    }

    .orderChange {
      height: 60px;
      width: 1200px;
      margin: 30px auto 20px auto;
    }
  }

  .orderTitle {
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 30px;
    padding-top: 30px;
  }

  .address-form {
    max-width: 400px;
    margin: auto;
  }

  .full-height {
    height: 100vh;
  }
  .aside-container {
    padding: 20px;
    background-color: #f5f7fa;
    border-right: 1px solid #ebeef5;
  }
  .main-container {
    padding: 20px;
  }
  .tab-content {
    padding: 10px;
  }
  .keyword-tag {
    margin: 5px;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .button-new-tag {
    margin-left: 10px;
  }
  .divider-line {
    border-top: 1px dashed #dcdfe6;
    margin: 20px 0;
  }
  .saved-mapping {
    margin-top: 20px;
  }
  .saved-mapping h4 {
    margin-bottom: 10px;
  }
  .keyword-tag-display, .keyword-tag-list {
    margin: 2px;
  }
  .book-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .result-summary {
    margin-top: 20px;
    padding: 15px;
    background-color: #e6f7ff;
    border-left: 5px solid #1890ff;
  }
  .highlight {
    font-weight: bold;
    color: #1890ff;
    font-size: 1.2em;
  }
  .el-table__row.red-row {
    background: #fef0f0;
  }

  .periodical-order, .arrival-info {
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;
    margin-top: 15px;
  }
  
  .demo-form-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .el-pagination {
    margin-top: 15px;
    text-align: right;
  }

  .journal-filter {
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;
  }
  
  .filter-form {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .journal-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .journal-title {
    color: #1890ff;
    cursor: pointer;
    text-decoration: underline;
  }
  
  .journal-cover {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8e8e8;
  }
  
  .journal-cover img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  
  .no-cover {
    color: #999;
    font-size: 14px;
  }
  
  /* 新增：在线订购相关样式 */
  .journal-search-container {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    margin-top: 15px;
  }
  
  .search-header {
    margin-bottom: 20px;
  }
  
  .search-header h3 {
    margin-bottom: 15px;
    color: #1890ff;
  }
  
  .search-form {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 15px;
  }
  
  .advanced-filter {
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 20px;
  }
  
  .results-stats {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .cart-info {
    margin-top: 10px;
  }
  
  .el-input-number {
    width: 120px;
  }
</style>


// WEBPACK FOOTER //
// src/views/ChildPages/Order-Over1.vue